<template>
  <div class="main-container">
    <OrderStep class="order-step" :current="2"></OrderStep>
    <div class="order-detail">
      <div class="title">提交订单成功</div>
      <div class="detail">
        提交订单成功，请您尽快支付；订单号：{{
          order.order_number
        }}
        应付金额：{{ (order.order_price + order.ship_price) | price }}
      </div>
      <div class="tip">
        请您在
        {{ $store.state.commonSetting.cancel_order_time }}
        分钟内完成支付，否则订单会被自动取消。
      </div>
    </div>
    <div class="pay">
      <div class="title">选择支付方式</div>
      <div class="tab">
        <el-tabs v-model="payType" @tab-click="payChange">
          <el-tab-pane
            name="wx"
            v-if="payConfig.wxPay && payConfig.wxPay.is_available == 1"
          >
            <div slot="label" class="pay-label">
              <img class="icon-wx" src="@/assets/images/order/icon-wx.png" />
              <span>微信支付</span>
            </div>
          </el-tab-pane>
          <el-tab-pane
            name="ali"
            v-if="payConfig.aliPay && payConfig.aliPay.is_available == 1"
          >
            <div slot="label" class="pay-label">
              <img
                class="icon-wx"
                src="@/assets/images/order/icon-alipay.png"
              />
              <span>支付宝支付</span>
            </div>
          </el-tab-pane>

          <el-tab-pane
            name="huabei"
            v-if="payConfig.aliPay && payConfig.aliPay.is_available == 1 && order.order_is_bystages==1"
          >
            <div slot="label" class="pay-label">
              <img
                class="icon-wx"
                src="@/assets/images/order/huabei.png"
              />
              <span>花呗支付</span>
            </div>
          </el-tab-pane>

        </el-tabs>
        <div class="price-container">
          <span class="label">支付金额：</span>
          <div class="price-wrap">
            <Currency></Currency>
            <span class="price">
              {{ (order.order_price + order.ship_price) | price }}
            </span>
          </div>
        </div>
      </div>

      <div class="fenqi-box" v-if="payType=='huabei'" style="display: flex;padding-left: 30px;margin-top: 20px;">


            <el-checkbox-group v-model="fenqi_type" >
              <el-checkbox @change="val => radioChange(val, item.qi_number)" :label="item.qi_number" v-for="(item,index) in huabeiList" :key="index" style="margin-right: 10px;">
                
                <span>￥{{ item.fenqi_price }}</span>
                <span v-if="item.qi_number!=0"> X {{ item.qi_number }}期</span>
                <span style="color: red;">（{{ item.content }}）</span>

              </el-checkbox>
            </el-checkbox-group>

      </div>

      <div class="main" v-if="payConfig.wxPay.appId || payConfig.aliPay.appId">



        <p class="p1">{{ payType == "wx" ? "微信" : "支付宝" }}支付</p>
        <p class="p2">
          请使用{{ payType == "wx" ? "微信" : "支付宝" }}扫描下方二维码完成支付
        </p>
        <div class="er-img">
          <vue-qr
            v-if="codeUrl"
            :text="codeUrl"
            :size="160"
            :margin="0"
          ></vue-qr>
        </div>
        <div class="refresh" @click="payChange">
          <img src="@/assets/images/order/icon-refresh.png" />
          <span>点击刷新二维码</span>
        </div>
      </div>
      <div class="main" v-else>
        <span>暂无可选支付方式</span>
      </div>
    </div>
  </div>
</template>
<script>
import OrderStep from "./components/OrderStep.vue";
import VueQr from "vue-qr";
let timer;

export default {
  name: "OrderPay",
  components: {
    OrderStep,
    VueQr,
  },
  data() {
    return {
      id: "",
      order: {},
      payType: "wx",
      codeUrl: "",
      shop_id: this.$route.query.shop_id,
      payConfig: {
        aliPay: {
          is_available: 2,
          appId: "",
        },
        wxPay: {
          is_available: 2,
          appId: "",
        },
      },
      default_check: "wx",
      huabeiList:[],
      is_fenqi:2,
      fenqi_type: [],
      isFirstTime: true
    };
  },
  async created() {
    this.payConfig = await this.$http.get(
      "/api/app/systemSet/available/payConfig",
    );
    if (!(this.payConfig.wxPay && this.payConfig.wxPay.is_available == 1)) {
      this.payType = "ali";
    }
    this.id = this.$route.params.id;
    this.order = await this.$http.post("/api/app/myOrder/detail", {
      order_id: this.id,
    });
    if (this.order.order_status == 2) {
      this.$router.push({
        name: "OrderSuccess",
        params: { id: this.order.id },
        query: { shop_id: this.shop_id },
      });
    }
    this.payChange();
  },
  watch:{
    fenqi_type:{
      handler(newVal,oldVal) {

        if (this.isFirstTime) {
          this.isFirstTime = false;
          return;
        }

        if(newVal&&oldVal&&newVal[0]!=oldVal[0]){

          if(newVal[0]==0){
            this.is_fenqi = 2
          }else{
            this.is_fenqi = 1
          }
          this.editFenqiPay(newVal[0]).then(res=>{

            this.getPay()
          })
          
        }
      },
    }
  },
  methods: {

    async editFenqiPay(qi_number){
      let data={
        order_id:this.order.id,         
        fenqi_num:qi_number||qi_number==0?qi_number:this.fenqi_type[0],         
        is_fenqi:this.fenqi_type==0?2:this.is_fenqi,//1分期 2不分期
      }

      await this.$http.post("/api/app/Order_alipayBystages", data)


    },
    radioChange(checked, value){
    
      this.fenqi_type = [value];
 
    },
    async getHuabeiList(){
      let data = await this.$http.get("/api/app/Get_alipay_stage", {
        fenqi_type:3,
        price:this.order.order_price
      })

      this.huabeiList = data.qi_stage_data

      this.fenqi_type = this.fenqi_type.length > 0 ? this.fenqi_type : [ data.qi_stage_data.find(item => item.default).qi_number ]

      this.editFenqiPay()
    },
    async getPay(){
        if (!this.payConfig.wxPay.appId && !this.payConfig.aliPay.appId) {
          return;
        }
        if (timer) {
          clearInterval(timer);
        }
        this.codeUrl = "";
        let data = await this.$http.post("/api/app/pay", {
          type: this.payType=='huabei'?'ali': this.payType,
          order_number: this.order.order_number,
        });
        this.codeUrl = data.response.code_url;
        timer = setInterval(async () => {
          let data = await this.$http.post(
            "/api/app/myOrder/detail",
            {
              order_id: this.id,
            },
            { showLoading: false, isAuthRequest: true },
          );
          if (data.order_status == 2 || data.pay_status == 2) {
            clearInterval(timer);
            this.$router.push({
              name: "OrderSuccess",
              params: { id: this.id },
              query: {
                type: this.$route.query.type,
                spell_id: this.$route.query.spell_id,
                shop_id: this.shop_id,
              },
            });
          }
        }, 1000);
    },

    async payChange() {
      // if (!this.payType) {
      //   this.$info("请选择支付方式");
      //   return;
      // }
      if(this.payType =='huabei'){
        this.getHuabeiList().then(res=>{

          this.getPay()
        })
        
        this.is_fenqi = 1
      }
      else if(this.payType =='ali'){
        this.is_fenqi = 2
          this.editFenqiPay(0).then(res=>{

            this.getPay()
          })
      }
      
      else{
        this.is_fenqi = 2

        this.getPay()
      }

      
    },
  },
  destroyed() {
    if (timer) {
      clearInterval(timer);
    }
  },
};
</script>
<style lang="scss" scoped>
@import "@/assets/css/varibles.scss";

.main-container {
  padding-top: 30px;
}

.order-step {
  border-radius: 10px;
}

.order-detail {
  background-color: white;
  padding: 16px 32px;
  margin: 20px 0;
  border-radius: 10px;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    margin-bottom: 14px;
  }
  .detail {
    font-size: 14px;
    color: rgba(0, 0, 0, 0.65);
  }
  .tip {
    height: 22px;
    font-size: 12px;
    color: #999;
    line-height: 22px;
    margin-top: 4px;
  }
}

.pay {
  background-color: white;
  padding: 16px 0;
  margin-bottom: 30px;
  border-radius: 10px;
  .title {
    font-size: 16px;
    font-weight: bold;
    color: rgba(0, 0, 0, 0.85);
    padding: 0 32px 20px 32px;
  }
  .tab {
    position: relative;
    /deep/ .el-tabs__nav-wrap {
      &::after {
        height: 1px;
      }
      .el-tabs__nav-scroll {
        padding: 0 30px;
        .el-tabs__item {
          height: 50px;
        }
      }
    }

    .pay-label {
      display: flex;
      align-items: center;
      height: 50px;
      .icon-wx {
        width: 26px;
        height: 26px;
        margin-right: 6px;
      }
      span {
        font-size: 14px;
        color: #595959;
      }
    }
    .price-container {
      position: absolute;
      right: 36px;
      top: 10px;
      display: flex;
      align-items: center;
      .label {
        height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(89, 89, 89, 1);
        line-height: 20px;
        margin-right: 18px;
      }
      .price-wrap {
        display: flex !important;
        align-items: center;
        justify-content: center;
        height: 33px;
        font-size: 24px;
        font-family: PingFangSC-Medium, PingFang SC;
        font-weight: 500;
        color: rgba(238, 31, 31, 1);
        line-height: 33px;
      }
    }
  }

  .main {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 40px 0;
    .p1 {
      font-size: 22px;
      font-family: PingFangSC-Medium, PingFang SC;
      font-weight: 500;
      color: rgba(0, 0, 0, 0.85);
      line-height: 24px;
    }
    .p2 {
      padding: 6px 0 20px 0;
      font-size: 12px;
      font-family: PingFangSC-Regular, PingFang SC;
      font-weight: 400;
      color: rgba(102, 102, 102, 1);
      line-height: 22px;
    }
    .er-img {
      text-align: center;
    }
    .refresh {
      display: flex;
      align-items: center;
      padding-top: 10px;
      cursor: pointer;
      img {
        width: 12px;
        height: 12px;
        margin-right: 4px;
      }
      span {
        font-size: 12px;
        color: #666;
      }
    }
  }
}



</style>
